import React, { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const SiteContext = createContext(null);
export const useSite = () => useContext(SiteContext);

const FALLBACK = {
  contact_info: { org_name: "ItsAllAboutJesus Outreach and Help Center", email: "", phone: "" },
  social_links: { facebook: "https://www.facebook.com/groups/10150150877730241" },
  footer: {
    org_name: "ItsAllAboutJesus Outreach and Help Center",
    tagline: "Faith in action. People helping people. Jesus at the center.",
    copyright: "© 2026 ItsAllAboutJesus Outreach and Help Center. All Rights Reserved.",
    managed_by_text: "Site Design and Managed by Prestigious Companies",
    managed_by_url: "https://www.prestigiouscompanies.org",
  },
  site_content: {},
  impact_stats: [],
  site_settings: { logo_url: "/logo.png" },
};

export function SiteProvider({ children }) {
  const [site, setSite] = useState(FALLBACK);
  const [config, setConfig] = useState({ service_categories: [], assistance_types: [] });

  useEffect(() => {
    api.get("/public/site").then(({ data }) => {
      const merged = { ...FALLBACK };
      Object.keys(data || {}).forEach((k) => { if (data[k]) merged[k] = data[k]; });
      setSite(merged);
    }).catch(() => {});
    api.get("/public/config").then(({ data }) => setConfig(data)).catch(() => {});
  }, []);

  return <SiteContext.Provider value={{ site, config }}>{children}</SiteContext.Provider>;
}
